import {Routes, RouterModule} from '@angular/router';
import {ZerothTabComponent} from './buyback-form/main-section/tabs/zeroth-tab/zeroth-tab.component';
import {FirstTabComponent} from './buyback-form/main-section/tabs/first-tab/first-tab.component';
import {SecondTabComponent} from './buyback-form/main-section/tabs/second-tab/second-tab.component';
import {ThirdTabComponent} from './buyback-form/main-section/tabs/third-tab/third-tab.component';
import {FourthTabComponent} from './buyback-form/main-section/tabs/fourth-tab/fourth-tab.component';
import {LastTabComponent} from './buyback-form/main-section/tabs/last-tab/last-tab.component';
import {HealthCheck} from './health-check/health-check.component';
import {NgModule} from '@angular/core';
import {
  OnlySavedCategoryGuard,
  OnlySavedSecondTabGuard,
  OnlySavedSellerTabGuard,
  OnlySavedDeliveryTabGuard,
} from './buyback-form/route-guard';

const appRoutes: Routes = [
  {path: 'status', component: HealthCheck},
  {path: 'model-secimi', component: FirstTabComponent},
  {path: 'cihaz-durumu', component: SecondTabComponent, canActivate: [OnlySavedCategoryGuard]},
  {path: 'iletisim-bilgileri', component: ThirdTabComponent, canActivate: [OnlySavedSecondTabGuard]},
  {path: 'teslimat-adimlari', component: FourthTabComponent, canActivate: [OnlySavedSellerTabGuard]},
  {path: 'sonuc', component: LastTabComponent, canActivate: [OnlySavedDeliveryTabGuard]},
  {path: ':categoryName', component: ZerothTabComponent},
  {path: '', component: ZerothTabComponent}
];

@NgModule({
  imports: [
    RouterModule.forRoot(
      appRoutes
    )
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule {

}



// WEBPACK FOOTER //
// ./src/app/app.routing.module.ts